import { chartDayTranslations, chartDefaultWeekDataObject } from "@";

// function to format the week days data
export const handelWeekDaysToArrayOfObjects = (data) => {
  if (!data) return [];
  const weekDays = Object.entries(data).map(([day, value]) => ({
    key: chartDayTranslations[day],
    value,
  }));

  const isAllZero = weekDays?.every((item) => item.value === 0);

  return isAllZero ? [] : weekDays;
};

// Function to convert week days data to an array of objects
export const weekDaysToArrayOfObjects = (data) => {
  if (!data) return chartDefaultWeekDataObject;

  return {
    total: data?.total,
    weekDays: handelWeekDaysToArrayOfObjects(data.weekCounts),
    percentage: data?.comparisonPercentage,
  };
};

// Function to get the fill and stroke colors based on the comparison percentage
export const getFillAndStrokeColors = (comparisonPercentage) => {
  const fillColor =
    comparisonPercentage >= 0
      ? "url(#colorDonationBlue)"
      : "url(#colorDonationRed)";
  const strokeColor = comparisonPercentage >= 0 ? "#4E1AC7" : "#F54A41";
  return { fillColor, strokeColor };
};
